module.exports = function getDataFromHtml (html) {
    var content = html.replace('<body', '<div id="body"').replace('</body>', '</div>');
    var $buffer = $('<div/>');
    $buffer.html(content);

    var json = {
        content:  $buffer.find('#xhr').html(),
        title: $buffer.find('title').text(),
        pageClass:  $buffer.find('#body').attr('class'),
        originalContent: html
    }
    return json;
}


// WEBPACK FOOTER //
// ./core/xhrController/getDataFromHtml.js